import { render, staticRenderFns } from "./AddTabStaffAccount.vue?vue&type=template&id=17ef2a38&scoped=true"
import script from "./AddTabStaffAccount.vue?vue&type=script&lang=js"
export * from "./AddTabStaffAccount.vue?vue&type=script&lang=js"
import style0 from "./AddTabStaffAccount.vue?vue&type=style&index=0&id=17ef2a38&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ef2a38",
  null
  
)

export default component.exports